var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510.447 510.447",
    height: 512,
    viewBox: "0 0 510.447 510.447",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_373_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_206_",
    d: "m139.224 510.447h-6.333c-40.62 0-73.667-33.047-73.667-73.667s33.047-73.667 73.667-73.667h50v-47.563h30v47.563h109.333c28.651 0 52.425-17.749 59.157-44.165l29.071 7.408c-10.176 39.93-45.632 66.757-88.228 66.757h-109.334v43.667c0 40.62-33.046 73.667-73.666 73.667zm-6.334-117.334c-24.078 0-43.667 19.589-43.667 43.667s19.589 43.667 43.667 43.667h6.333c24.078 0 43.667-19.589 43.667-43.667v-43.667z",
    fill: "#0065a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1689_",
    d: "m381.38 318.948c-6.732 26.416-30.505 44.165-59.157 44.165h-109.333v-47.563h-15.667v166.565c9.801-12.511 15.667-28.247 15.667-45.336v-43.667h109.333c42.596 0 78.052-26.827 88.228-66.757z",
    fill: "#00317e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_194_",
    cx: 398.89,
    cy: 285.447,
    fill: "#00317e",
    r: 37.333
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_196_",
    d: "m398.89 337.78c-28.856 0-52.333-23.477-52.333-52.333 0-28.857 23.477-52.334 52.333-52.334 28.857 0 52.333 23.477 52.333 52.334.001 28.857-23.476 52.333-52.333 52.333zm0-74.667c-12.314 0-22.333 10.019-22.333 22.334 0 12.314 10.019 22.333 22.333 22.333 12.315 0 22.333-10.019 22.333-22.333.001-12.315-10.018-22.334-22.333-22.334z",
    fill: "#8a8aa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_171_",
    d: "m197.224 330.551c-73.888 0-134-60.112-134-134v-131.91c0-26.545 21.596-48.141 48.14-48.141h14.554v30h-14.554c-10.002 0-18.14 8.138-18.14 18.141v131.91c0 57.346 46.654 104 104 104s104-46.654 104-104v-130.1c0-10.002-8.138-18.14-18.14-18.14h-14.832v-30h14.832c26.544 0 48.14 21.596 48.14 48.14v130.1c0 73.887-60.113 134-134 134z",
    fill: "#bdbdd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1701_",
    d: "m283.083 18.312h-14.832v30h14.832c10.002 0 18.14 8.138 18.14 18.14v130.1c0 57.346-46.654 104-104 104v30c73.888 0 134-60.112 134-134v-130.1c.001-26.545-21.595-48.14-48.14-48.14z",
    fill: "#ababc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_310_",
    d: "m244.918 0c-17.369 0-31.5 14.131-31.5 31.5s14.131 31.5 31.5 31.5h30.833v-63z",
    fill: "#00317e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_172_",
    d: "m149.251 0h-30.833v63h30.833c17.369 0 31.5-14.131 31.5-31.5s-14.13-31.5-31.5-31.5z",
    fill: "#0065a3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.cc1a1478dbc64a0a586390eb1f2405d3.svg";
export { ForwardRef as ReactComponent };